<script lang="ts">
  import Modal from "$app/components/Modal.svelte"

  let props = $props()
  let { open } = $state(props.open)

  let title

  const openViewModalHandler = () => {
    openViewModal = true
  }
</script>

<Modal
  bind:open
  closeButton={true}
  closeOnEsc={false}
  closeOnOuterClick={false}
>
  <div class="px-4 my-4">
    <div class="flex flex-col justify-center px-6">
      <h3 class="py-3 text-2xl text-center font-bold" bind:this={title}>
        Welcome to the new Lead With Purpose Platform!
      </h3>
      <div class="text-center" style="padding:56.25% 0 0 0;position:relative;">
        <iframe
          src="https://player.vimeo.com/video/542449957?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
          style="position:absolute;top:0;left:0;width:100%;height:100%;"
          title="New Platform"
        ></iframe>
      </div>
      <script src="https://player.vimeo.com/api/player.js"></script>
    </div>
  </div>
</Modal>
